import { DeliveryPromise } from "@omni/types/api/cart/bff/shared/deliveryPromise.model";
import { DeliveryPromiseType } from "@omni/types/api/product/bff/shared/enums/deliveryPromiseType.enum";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";

import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { cartDeliveryPromiseTranslationKey } from "@/utils/deliveryPromise";

type CartItemInfoDeliveryMethodProps = {
    isWarrantyDeposit: boolean;
    isBoxArticle: boolean;
    deliveryPromise?: DeliveryPromise | null;
    withRemove: boolean;
    deliveryType?: DeliveryType;
    boxLogisticInformation?: string | null;
    sku: string | undefined;
    ccTooltipInfo: string;
    dsvTooltipInfo: string;
};

const CartItemInfoDeliveryMethod = ({
    deliveryPromise,
    isWarrantyDeposit,
    isBoxArticle,
    deliveryType,
    withRemove,
    boxLogisticInformation,
    sku,
    ccTooltipInfo,
    dsvTooltipInfo
}: CartItemInfoDeliveryMethodProps) => {
    const { t } = useGranite();

    if (isWarrantyDeposit || !deliveryPromise) {
        return null;
    }

    if (isBoxArticle && deliveryType === DeliveryType.ClickAndCollect) {
        return (
            <div
                className={cn(
                    "tw:text-success tw:wrap-break-word  tw:font-bold"
                )}
            >
                {boxLogisticInformation ||
                    t(`ecommerce.label.pickup.box.${sku}`)}
            </div>
        );
    }
    const determineTooltipInfo = (deliveryPromiseType: DeliveryPromiseType) => {
        let tooltipInfo = null;

        if (
            DeliveryPromiseType.AvailableForPickUpInStore ===
            deliveryPromiseType
        ) {
            tooltipInfo = ccTooltipInfo;
        } else if (
            DeliveryPromiseType.AvailableForHomeDelivery === deliveryPromiseType
        ) {
            tooltipInfo = dsvTooltipInfo;
        }

        return tooltipInfo;
    };

    const deliveryPromiseType = deliveryPromise.deliveryPromiseType;
    const cartDeliveryPromiseTK = cartDeliveryPromiseTranslationKey({
        deliveryPromise: deliveryPromise,
        deliveryType: deliveryType,
        withRemove: withRemove
    });
    const tooltipInfo = determineTooltipInfo(
        deliveryPromiseType as DeliveryPromiseType
    );

    if (!cartDeliveryPromiseTK) {
        return null;
    }

    return (
        <div
            className={cn("tw:text-success tw:wrap-break-word  tw:font-bold", {
                "tw:text-success":
                    deliveryPromiseType !== DeliveryPromiseType.NoStock,
                "tw:text-danger":
                    deliveryPromiseType === DeliveryPromiseType.NoStock
            })}
        >
            {t(
                cartDeliveryPromiseTK,
                (deliveryPromise as DeliveryPromise).deliveryTime,
                t(
                    `product.deliveryPromise.timeUnits.${
                        (deliveryPromise as DeliveryPromise).deliveryTimeUnit
                    }`
                )
            )}
            {tooltipInfo && <Tooltip innerHTML={tooltipInfo} />}
        </div>
    );
};

export { CartItemInfoDeliveryMethod };
